export default __webpack_public_path__ + "static/media/QRPHP.a4a7600a.webp";